import * as React from "react";
import { SVGProps } from "react";
export const ToggleOffIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6 15C4.61133 15 3.43067 14.514 2.458 13.542C1.486 12.5693 1 11.3887 1 10C1 8.61133 1.486 7.43067 2.458 6.458C3.43067 5.486 4.61133 5 6 5H14C15.3887 5 16.5693 5.486 17.542 6.458C18.514 7.43067 19 8.61133 19 10C19 11.3887 18.514 12.5693 17.542 13.542C16.5693 14.514 15.3887 15 14 15H6ZM6 13.5H14C14.972 13.5 15.7983 13.1597 16.479 12.479C17.1597 11.7983 17.5 10.972 17.5 10C17.5 9.028 17.1597 8.20167 16.479 7.521C15.7983 6.84033 14.972 6.5 14 6.5H6C5.028 6.5 4.20167 6.84033 3.521 7.521C2.84033 8.20167 2.5 9.028 2.5 10C2.5 10.972 2.84033 11.7983 3.521 12.479C4.20167 13.1597 5.028 13.5 6 13.5ZM6 12.5C6.69467 12.5 7.285 12.257 7.771 11.771C8.257 11.285 8.5 10.6947 8.5 10C8.5 9.30533 8.257 8.715 7.771 8.229C7.285 7.743 6.69467 7.5 6 7.5C5.30533 7.5 4.715 7.743 4.229 8.229C3.743 8.715 3.5 9.30533 3.5 10C3.5 10.6947 3.743 11.285 4.229 11.771C4.715 12.257 5.30533 12.5 6 12.5Z"
            fill="currentColor"
        />
    </svg>
);
ToggleOffIcon.displayName = "ToggleOffIcon";
